module.exports = __webpack_public_path__ + "static/img/lxth.36eb0a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/lxth.jpg
// module id = 7PU3
// module chunks = 0